import { Breadcrumb as ChakraBreadcrumb } from "@chakra-ui/react";
import type { ComponentProps, PropsWithChildren } from "react";
import type { BreadcrumbLinkSharedProps } from "./BreadcrumbLink.props";

export default function BreadcrumbLink(
  props: BreadcrumbLinkProps
): JSX.Element {
  const { isCurrentPage, ...rest } = props;
  if (isCurrentPage) {
    return <ChakraBreadcrumb.CurrentLink {...rest} />;
  }
  return <ChakraBreadcrumb.Link {...rest} />;
}

type ChakraBreadcrumbLinkProps = ComponentProps<typeof ChakraBreadcrumb.Link>;
type ChakraBreadcrumbCurrentLinkProps = ComponentProps<
  typeof ChakraBreadcrumb.CurrentLink
>;

export type BreadcrumbLinkProps = PropsWithChildren<
  BreadcrumbLinkSharedProps &
    Omit<ChakraBreadcrumbLinkProps, keyof ChakraBreadcrumbCurrentLinkProps> &
    Partial<ChakraBreadcrumbLinkProps & ChakraBreadcrumbCurrentLinkProps>
>;
